module.exports = __webpack_public_path__ + "img/pr-5.e37e29ff.png";